import React from 'react'
import t from '~t'
import { API_ENDPOINT_URL } from '~data/constants/app'
import { Menu, MenuItem, MenuSeparator, Popover, Icon } from '~ui';
import { target } from '~target'
import { useSelector } from 'react-redux'

export default function BookmarksItemContextmenu({
    _id, link, important, access, reparse, cache, fileType, type,
    onContextMenuClose, onRemoveClick, onCopyLinkClick,
    onSelectClick, onImportantClick, onReparseClick
}) {
    const ai_assistant = useSelector(state=>state.config.ai_assistant)

    return (
        <Popover onClose={onContextMenuClose}>
            <Menu>
                <MenuItem href={link} rel='noopener' target='_blank'>
                    {t.s('openInNewTab')}
                </MenuItem>

                <MenuItem onClick={onCopyLinkClick}>
                    {t.s('copyLinkToClipboard')}
                </MenuItem>

                <MenuSeparator />

                {ai_assistant ? (
                    <MenuItem to={`item/${_id}/ask`}>
                        {t.s('ask')} &nbsp;<Icon name='ai' />
                    </MenuItem>
                ) : null}

                {target != 'extension' && (
                    <MenuItem to={`item/${_id}/${type == 'link' ? 'web' : 'preview'}`}>
                        {t.s('preview')}
                    </MenuItem>
                )}

                {access && access.level >= 2 ? (
                    <MenuItem to={`item/${_id}/cache`}>
                        {cache && cache != 'ready' ? '⚠️ ' : ''}{t.s('openWebArchive')}
                    </MenuItem>
                ) : null}

                {fileType ? (
                    <MenuItem href={`${API_ENDPOINT_URL}raindrop/${_id}/file?download`}>
                        {t.s('download')}
                    </MenuItem>
                ) : null}

                {access && access.level >= 3 ? (
                    <>
                        <MenuSeparator />

                        <MenuItem onClick={onSelectClick}>
                            {t.s('select')}
                        </MenuItem>

                        <MenuItem onClick={onImportantClick}>
                            {important ? t.s('removeFromFavorites') : t.s('addToFavorites')}
                        </MenuItem>

                        {!reparse ? (
                            <MenuItem onClick={onReparseClick}>
                                {t.s('refreshPreview')}
                            </MenuItem>
                        ) : null}

                        <MenuSeparator />

                        <MenuItem to={`item/${_id}/edit`}>
                            {t.s('edit')}
                        </MenuItem>

                        <MenuItem onClick={onRemoveClick}>
                            {t.s('remove')}
                        </MenuItem>
                    </>
                ) : null}
            </Menu>
        </Popover>
    )
}